const MINERAL_INTELLIGENCE = {
    LANDING_PAGE: {
        RESOURCE_ID: 'complianceDashboard',
    },
    INSIGHTS_PAGE: {
        RESOURCE_ID: 'complianceInsights',
    },
};

export default MINERAL_INTELLIGENCE;
